const recruitmentMenu: any = {
  id: "recruiter",
  title: "Recruitment",
  translate: "MENU.RECRUITMENT",
  type: "collapsible",
  icon: "briefcase",
  capability: "show_menu_recruitment",
  children: [
    {
      id: "list-candidate",
      title: "Candidati",
      translate: "MENU.CANDIDATES",
      type: "item",
      capability: "show_candidate_list",
      url: "dashboard/candidate/list",
    },
    {
      id: "requests-eligible-candidate-list",
      title: "Candidati proposti",
      translate: "MENU.CANDIDATES_PROPOSED",
      type: "item",
      url: "dashboard/requests-eligible-candidate-list",
      capability: "view_request_suitable_candidate_list",
    },
    {
      id: "hired-candidates",
      title: "Candidati assunti",
      translate: "MENU.HIRED_CANDIDATES",
      type: "item",
      url: "dashboard/hired-candidates/list",
      capability: "show_hired_candidate_list",
    },
    {
      id: "requests-list",
      title: "Richieste clienti",
      translate: "MENU.CUSTOMERS_REQUESTS",
      type: "item",
      url: "dashboard/requests-list",
      capability: "view_customers_requests_list",
    },
    {
      id: "bargaining",
      title: "Contrattazione",
      translate: "MENU.BARGAINING",
      type: "item",
      capability: "show_menu_bargaining_list",
      url: "dashboard/bargaining-list",
    },
    {
      id: "recruitment_stats",
      title: "Statistiche recruitment",
      translate: "MENU.RECRUITMENT_STATISTICS",
      type: "item",
      capability: "show_menu_recruitment_stats",
      url: "dashboard/recruitment/stats",
    },
    {
      id: "commercial_stats",
      title: "Statistiche commerciali",
      translate: "MENU.COMMERCIAL_STATISTICS",
      type: "item",
      capability: "view_commercial_statistic",
      url: "dashboard/commercial/stats",
    },
  ],
  order: 11,
};

export default recruitmentMenu;
